<button class="btn btn-clear" [id]="'arrow-move-' + dir" (click)="onClick.emit()" tabindex="0">
    <i class="fa fa-arrow-{{dir}}" aria-hidden="true"></i>
</button>